import { render, staticRenderFns } from "./subSummaryBusinessSkillsScores.vue?vue&type=template&id=2c6a0155&scoped=true"
import script from "./subSummaryBusinessSkillsScores.vue?vue&type=script&lang=js"
export * from "./subSummaryBusinessSkillsScores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a0155",
  null
  
)

export default component.exports